<template>
  <span>
    <div
      v-if="onlyLogo"
      class="d-flex align-center justify-center"
    >
      <component
        :is="getChannelComponent(item.channel)"
        :channel="item.channel"
      />
      <slot />
    </div>
    <span v-else>
      <v-row class="channel-select-item">
        <component
          :is="getChannelComponent(item.channel)"
          :channel="item.channel"
        />
        <div>
          <div class="channel-select-item__text text-truncate">
            {{ item.text }}
          </div>
          <div class="caption grey--text text-truncate">
            {{ usernameLabel }}
          </div>
        </div>
      </v-row>
    </span>
  </span>
</template>

<script>
import { findSocialIcon, isGMB } from '@/utils/channels';

export default {
  name: 'ChannelSelectItem',
  props: {
    item: {
      type: Object,
      required: true,
    },
    onlyLogo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    usernameLabel() {
      return isGMB(this.item.channel) ? this.item.username : `@${this.item.username}`;
    },
  },
  methods: {
    getChannelComponent(channel) {
      return findSocialIcon(channel);
    },
  },
};
</script>

<style scoped lang="scss">
  .channel-select-item {
    width: 100%;
    display: grid;
    align-items: center;
    grid-template-columns: 70px 170px;
  }
</style>
